import { Fragment, h } from 'preact';
import { Text } from 'preact-i18n';
import { PillsRow } from '../pill/pills-row';
import * as styles from './panel.scss';

interface Props {
  terms: Record<string, number>;
  onTermClick: (term: string) => void;
  activeTerm: string | null;
}
export const MentionedTerms = ({ terms, onTermClick, activeTerm }: Props): h.JSX.Element | null => {
  const termsEntries = Object.entries(terms);
  if (termsEntries.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <div className={styles.mentionedTermsTextBlock}>
        <Text id="taxonomyTranscript.mentionedTerms">Mentioned terms</Text>:
      </div>
      <PillsRow activeTerm={activeTerm} termEntries={termsEntries} onTermClick={onTermClick} />
    </Fragment>
  );
};
